import { render, staticRenderFns } from "./exchangeRecord.vue?vue&type=template&id=29ae65f0&scoped=true&"
import script from "./exchangeRecord.vue?vue&type=script&lang=js&"
export * from "./exchangeRecord.vue?vue&type=script&lang=js&"
import style0 from "./exchangeRecord.vue?vue&type=style&index=0&id=29ae65f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ae65f0",
  null
  
)

export default component.exports